import { render, staticRenderFns } from "./createOrder.vue?vue&type=template&id=6ecdd551&scoped=true"
import script from "./createOrder.vue?vue&type=script&lang=js"
export * from "./createOrder.vue?vue&type=script&lang=js"
import style0 from "./createOrder.vue?vue&type=style&index=0&id=6ecdd551&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ecdd551",
  null
  
)

export default component.exports